function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';
import { FunnelFill } from 'react-bootstrap-icons';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { EVENT_TYPE_BIRTH, EVENT_TYPE_DEATH } from '../api';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function SortBySelect(_ref) {
  var disabled = _ref.disabled;
  var intl = useIntl();
  return /*#__PURE__*/_jsx(Field, {
    name: "sortBy",
    render: function render(_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Form.Label, {
          htmlFor: input.name,
          srOnly: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "form.event"
          })
        }), /*#__PURE__*/_jsxs(InputGroup, {
          children: [/*#__PURE__*/_jsx(InputGroup.Prepend, {
            children: /*#__PURE__*/_jsx(InputGroup.Text, {
              children: /*#__PURE__*/_jsx(FunnelFill, {
                className: "icon"
              })
            })
          }), /*#__PURE__*/_jsxs(Form.Control, _objectSpread(_objectSpread({
            as: "select",
            custom: true,
            disabled: disabled
          }, input), {}, {
            children: [/*#__PURE__*/_jsx("option", {
              value: EVENT_TYPE_BIRTH,
              children: intl.formatMessage({
                id: 'common.event.birth'
              })
            }), /*#__PURE__*/_jsx("option", {
              value: EVENT_TYPE_DEATH,
              children: intl.formatMessage({
                id: 'common.event.death'
              })
            })]
          }))]
        })]
      });
    }
  });
}
SortBySelect.propTypes = {
  disabled: PropTypes.bool.isRequired
};